import { V3Record } from 'data/helpers/V3Record.js'
import { trackpointMetrics } from 'lib/metricsCalculator'

export const Route = V3Record('route', {
  name: null,
  description: null,
  defaultBasemap: 'rwgps',
  visibility: 0,
  photos: [],
  photoIds: [],
  trackPoints: [],
  coursePoints: [],
  rawPoints: [],
  pointsOfInterest: [],
  poiIds: [],
  elevationGain: null,
  elevationLoss: null,
  recreationTypeIds: [],
  pavementType: null,
  distance: null,
  postalCode: null,
  privacyCode: null,
  locality: null,
  administrativeArea: null,
  country: null,
  createdAt: null,
  updatedAt: null,
  userId: null,
  event: null,
  eventIds: [],
  experienceIds: [],
  club: null,
  boundingBox: null,
  metrics: null,
  pinned: false,
  segments: [],
  officialMapPdfUrl: null,
  highlightedPhotoId: null,
  hasCoursePoints: null,
  metricUnits: null,
  copiedFromName: null,
  copiedFromPath: null,
  bylineName: null,
  bylinePath: null,
  locked: null,
  archivedAt: null,
  tagNames: [],
  groupId: null, // HACK to allow for saving to groups
  plannerOptions: null, // this is how the planner passes defaultBasemap
  views: 0
}, {
  writeable: [
    'name',
    'description',
    'visibility',
    'trackPoints',
    'coursePoints',
    'pointsOfInterest',
    'recreationTypeIds',
    'userId',
    'eventIds',
    'tagNames',
    'groupId',
    'plannerOptions'
  ]
})

const _defaultDeserialize = Route.deserialize
const _defaultSerialize = Route.serialize
Route.deserialize = (fromRails) => {
  const route = _defaultDeserialize(fromRails)
  return route
    .set('rawPoints', route.trackPoints)
    .set('trackPoints', route.trackPoints ? trackpointMetrics(route.trackPoints) : null)
}

Route.serialize = (record, ...rest) => {
  const response = _defaultSerialize(record, ...rest)
  // reverse the above operation
  delete response.route.raw_points
  response.route.track_points = JSON.stringify(record.rawPoints)
  return response
}
